export default __webpack_public_path__ + "static/AntiqueOliveStd-Nord-9fbab60d9b705c254e61f876f55b6319.eot";